/**
 * 语言英文映射
 */
export const langEn: {
  [key: string]: string;
} = {
  aa: 'Afar',
  ab: 'Abkhazian',
  ace: 'Acehnese',
  ach: 'Achi',
  af: 'Afrikaans',
  ak: 'Akan',
  alz: 'Alur',
  am: 'Amharic',
  ao: 'Aromanian',
  ar: 'Arabic',
  as: 'Assamese',
  av: 'Avaric',
  awa: 'Awadhi',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  ban: 'Balinese',
  bbc: 'Batak Toba',
  bci: 'Baoulé',
  be: 'Belarusian',
  bem: 'Bemba',
  ber: 'Berber',
  bew: 'Betawi',
  bg: 'Bulgarian',
  bh: 'Bihari',
  bho: 'Bhojpuri',
  bik: 'Bikol',
  bm: 'Bambara',
  bn: 'Bengali',
  bo: 'Tibetan',
  br: 'Breton',
  bs: 'Bosnian',
  bts: 'Batak Simalungun',
  btx: 'Batak Karo',
  bua: 'Buriat',
  by: 'Belarusian',
  ca: 'Catalan',
  ce: 'Chechen',
  cgg: 'Chiga',
  ch: 'Chamorro',
  chk: 'Chuukese',
  chm: 'Mari',
  ckb: 'Central Kurdish',
  cnh: 'Hakha Chin',
  co: 'Corsican',
  cr: 'Cree',
  crh: 'Crimean Tatar',
  crs: 'Seychellois Creole',
  cs: 'Czech',
  cv: 'Chuvash',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German',
  din: 'Dinka',
  do: 'Dominican Creole',
  doi: 'Dogri',
  dov: 'Dombe',
  dv: 'Divehi',
  dyu: 'Dyula',
  dz: 'Dzongkha',
  ee: 'Ewe',
  el: 'Greek',
  en: 'English',
  eo: 'Esperanto',
  es: 'Spanish',
  et: 'Estonian',
  eu: 'Basque',
  fa: 'Persian',
  ff: 'Fulah',
  fi: 'Finnish',
  fil: 'Filipino',
  fj: 'Fijian',
  fo: 'Faroese',
  fon: 'Fon',
  fr: 'French',
  fur: 'Friulian',
  fy: 'West Frisian',
  ga: 'Irish',
  gaa: 'Ga',
  gd: 'Gaelic',
  gl: 'Galician',
  gn: 'Guarani',
  gom: 'Goan Konkani',
  gt: 'Gitxsan',
  gu: 'Gujarati',
  gv: 'Manx',
  ha: 'Hausa',
  he: 'Hebrew',
  hi: 'Hindi',
  hmn: 'Hmong',
  hr: 'Croatian',
  hrx: 'Hunsrik',
  ht: 'Haitian',
  hu: 'Hungarian',
  hy: 'Armenian',
  iba: 'Iban',
  id: 'Indonesian',
  ig: 'Igbo',
  ilo: 'Ilocano',
  iq: 'Mesopotamian Arabic',
  is: 'Icelandic',
  it: 'Italian',
  iu: 'Inuktitut',
  iw: 'Hebrew',
  ja: 'Japanese',
  jam: 'Jamaican Creole',
  jo: 'Jola-Fonyi',
  jv: 'Javanese',
  jw: 'Javanese',
  ka: 'Georgian',
  kac: 'Jingpo',
  ke: 'Kikuyu',
  kek: 'Kekchi',
  kg: 'Kongo',
  kha: 'Khasi',
  kk: 'Kazakh',
  kl: 'Kalaallisut',
  km: 'Central Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kr: 'Kanuri',
  kri: 'Krio',
  ktu: 'Kituba',
  ku: 'Kurdish',
  kv: 'Komi',
  kw: 'Cornish',
  ky: 'Kirghiz',
  la: 'Latin',
  lb: 'Luxembourgish',
  lg: 'Ganda',
  li: 'Limburgan',
  lij: 'Ligurian',
  lmo: 'Lombard',
  ln: 'Lingala',
  lo: 'Lao',
  lt: 'Lithuanian',
  ltg: 'Latgalian',
  lua: 'Luba-Lulua',
  luo: 'Luo',
  lus: 'Mizo',
  lv: 'Latvian',
  ly: 'Lycian',
  ma: 'Marathi',
  mad: 'Madurese',
  mai: 'Maithili',
  mak: 'Makasar',
  mam: 'Mam',
  mfe: 'Mauritian Creole',
  mg: 'Malagasy',
  mh: 'Marshallese',
  mi: 'Maori',
  min: 'Minangkabau',
  mk: 'Macedonian',
  ml: 'Malayalam',
  mn: 'Mongolian',
  mni: 'Manipuri',
  mo: 'Moldavian',
  mr: 'Marathi',
  ms: 'Malay',
  mt: 'Maltese',
  my: 'Burmese',
  nb: 'Norwegian Bokmål',
  ndc: 'Ndau',
  ne: 'Nepali',
  new: 'Newari',
  nhe: 'Eastern Huasteca Nahuatl',
  ni: 'Niuean',
  nl: 'Dutch',
  nn: 'Norwegian Nynorsk',
  no: 'Norwegian',
  nso: 'Northern Sotho',
  nus: 'Nuer',
  ny: 'Chichewa',
  oc: 'Occitan',
  om: 'Oromo',
  or: 'Oriya',
  os: 'Ossetian',
  pa: 'Punjabi',
  pag: 'Pangasinan',
  pam: 'Kapampangan',
  pap: 'Papiamento',
  pl: 'Polish',
  ps: 'Pashto',
  pt: 'Portuguese',
  pt_BR: 'Brazilian Portuguese',
  qa: 'Qashqai',
  qu: 'Quechua',
  rn: 'Rundi',
  ro: 'Romanian',
  rom: 'Romany',
  ru: 'Russian',
  rw: 'Kinyarwanda',
  sa: 'Sanskrit',
  sah: 'Yakut',
  sat: 'Santali',
  scn: 'Sicilian',
  sd: 'Sindhi',
  se: 'Northern Sami',
  sg: 'Sango',
  shn: 'Shan',
  si: 'Sinhala',
  sk: 'Slovak',
  sl: 'Slovenian',
  sm: 'Samoan',
  sn: 'Shona',
  so: 'Somali',
  sq: 'Albanian',
  sr: 'Serbian',
  ss: 'Swati',
  st: 'Southern Sotho',
  su: 'Sundanese',
  sus: 'Susu',
  sv: 'Swedish',
  sw: 'Swahili',
  szl: 'Silesian',
  ta: 'Tamil',
  tcy: 'Tulu',
  te: 'Telugu',
  tet: 'Tetum',
  tg: 'Tajik',
  th: 'Thai',
  ti: 'Tigrinya',
  tiv: 'Tiv',
  tj: 'Tajik',
  tk: 'Turkmen',
  tl: 'Tagalog',
  tm: 'Tamashek',
  tn: 'Tswana',
  to: 'Tonga',
  tpi: 'Tok Pisin',
  tr: 'Turkish',
  trp: 'Kokborok',
  ts: 'Tsonga',
  tt: 'Tatar',
  tum: 'Tumbuka',
  tw: 'Twi',
  ty: 'Tahitian',
  tyv: 'Tuvan',
  udm: 'Udmurt',
  ug: 'Uighur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  ve: 'Venda',
  vec: 'Venetian',
  vi: 'Vietnamese',
  wa: 'Walloon',
  war: 'Waray',
  wo: 'Wolof',
  xh: 'Xhosa',
  ye: 'Yeni',
  yi: 'Yiddish',
  yo: 'Yoruba',
  yua: 'Yucatec Maya',
  yue: 'Cantonese',
  zap: 'Zapotec',
  zh: 'Simplified Chinese',
  zh_cn: 'Simplified Chinese',
  zh_hk: 'Traditional Chinese (Hong Kong)',
  zh_tw: 'Traditional Chinese (Taiwan)',
  'zh-tw': 'Traditional Chinese',
  zm: 'Zamboanga Chavacano',
  zu: 'Zulu',
  ae: 'Avestan',
  an: 'Aragonese',
  bi: 'Bislama',
  cu: 'Church Slavic',
  ho: 'Hiri Motu',
  hz: 'Herero',
  ia: 'Interlingua',
  ie: 'Interlingue',
  ii: 'Sichuan Yi, Nuosu',
  ik: 'Inupiaq',
  io: 'Ido',
  ki: 'Kikuyu',
  kj: 'Kuanyama',
  ks: 'Kashmiri',
  lu: 'Luba-Katanga',
  na: 'Nauru',
  nd: 'North Ndebele',
  ng: 'Ndonga',
  nr: 'South Ndebele',
  nv: 'Navajo',
  oj: 'Ojibwa',
  pi: 'Pali',
  rm: 'Romansh',
  sc: 'Sardinian',
  sh: 'Serbo-Croatian',
  vo: 'Volapük',
  za: 'Zhuang',
  unknown: 'Unidentified',
};

/**
 * 语言中文映射
 */
export const langCn: {
  [key: string]: string;
} = {
  aa: '阿法尔语',
  ab: '阿布哈兹语',
  ace: '亚齐语',
  ach: '阿奇语',
  af: '南非语',
  ak: '阿坎语',
  alz: '阿卢尔语',
  am: '阿姆哈拉语',
  ao: '阿罗马尼亚语',
  ar: '阿拉伯语',
  as: '阿萨姆语',
  av: '阿瓦尔语',
  awa: '阿瓦德语',
  ay: '艾马拉语巴斯克语',
  az: '阿塞拜疆语',
  ba: '巴什基尔语',
  ban: '巴厘语',
  bbc: '巴塔克语',
  bci: '巴乌莱语',
  be: '白俄罗斯语',
  bem: '本巴语',
  ber: '柏柏尔语',
  bew: '巴达维语',
  bg: '保加利亚语',
  bh: '比哈尔语',
  bho: '博杰普尔语',
  bik: '比科尔语',
  bm: '班巴拉语',
  bn: '孟加拉国语',
  bo: '藏语',
  br: '布列塔尼语',
  bs: '波斯尼亚语',
  bts: '巴塔克西马隆贡语',
  btx: '巴塔克卡罗语',
  bua: '布里亚特语',
  by: '白俄罗斯语',
  ca: '加泰隆语',
  ce: '车臣语',
  cgg: '奇加语',
  ch: '查莫罗语',
  chk: '丘克语',
  chm: '马里语',
  ckb: '中库尔德语',
  cnh: '哈卡钦语',
  co: '科西嘉语',
  cr: '克里语',
  crh: '克里米亚鞑靼语',
  crs: '塞舌尔克里奥尔语',
  cs: '捷克语',
  cv: '楚瓦什语',
  cy: '韦尔斯语',
  da: '丹麦语',
  de: '德语',
  din: '丁卡语',
  do: '多米尼加克里奥尔语',
  doi: '多格拉语',
  dov: '多姆贝语',
  dv: '迪维西语',
  dyu: '迪乌拉语',
  dz: '宗喀语',
  ee: '埃维语',
  el: '希腊语',
  en: '英语',
  eo: '世界语',
  es: '西班牙语',
  et: '爱沙尼亚语',
  eu: '巴斯克语',
  fa: '波斯语',
  ff: '富拉语',
  fi: '芬兰语',
  fil: '菲律宾语',
  fj: '斐济语',
  fo: '法罗语',
  fon: '丰语',
  fr: '法语',
  fur: '弗留利语',
  fy: '菲士兰语',
  ga: '爱尔兰语',
  gaa: '加语',
  gd: '苏格兰盖尔语',
  gl: '加利西亚语',
  gn: '瓜拉尼语',
  gom: '果阿孔卡尼语',
  gt: '吉特克桑语',
  gu: '古吉拉特语',
  gv: '曼岛语',
  ha: '豪萨语',
  he: '希伯来语',
  hi: '印地语',
  hmn: '苗语',
  hr: '克罗地亚语',
  hrx: '亨斯里克语',
  ht: '海地克里奥尔语',
  hu: '匈牙利语',
  hy: '亚美尼亚语',
  iba: '伊班语',
  id: '印度尼西亚语',
  ig: '伊博语',
  ilo: '伊洛卡诺语',
  iq: '伊拉克阿拉伯语',
  is: '冰岛语',
  it: '意大利语',
  iu: '伊努克提图特语',
  iw: '希伯来语',
  ja: '日语',
  jam: '牙买加克里奥尔语',
  jo: '朱拉语',
  jv: '爪哇语',
  jw: '爪哇语',
  ka: '乔治亚语',
  kac: '景颇语',
  ke: '基库尤语',
  kek: '凯克奇语',
  kg: '刚果语',
  kha: '卡西语',
  kk: '哈萨克斯坦语',
  kl: '格陵兰语',
  km: '高棉语',
  kn: '康纳达语',
  ko: '韩语',
  kr: '卡努里语',
  kri: '克里奥尔语',
  ktu: '基图巴语',
  ku: '库德语',
  kv: '科米语',
  kw: '康瓦尔语',
  ky: '柯尔克孜语',
  la: '拉丁语',
  lb: '卢森堡语',
  lg: '卢干达语',
  li: '林堡语',
  lij: '利古里亚语',
  lmo: '伦巴第语',
  ln: '林格拉语',
  lo: '寮语',
  lt: '立陶宛语',
  ltg: '拉特加尔语',
  lua: '卢巴-卢卢阿语',
  luo: '卢奥语',
  lus: '米佐语',
  lv: '拉脱维亚语',
  ly: '吕西亚语',
  ma: '马拉地语',
  mad: '马都拉语',
  mai: '迈蒂利语',
  mak: '望加锡语',
  mam: '马姆语',
  mfe: '毛里求斯克里奥尔语',
  mg: '马拉加斯语',
  mh: '马绍尔语',
  mi: '毛利语',
  min: '米南佳保语',
  mk: '马其顿语',
  ml: '马拉亚拉姆语',
  mn: '蒙古语',
  mni: '曼尼普尔语',
  mo: '摩尔多瓦语',
  mr: '马拉提语',
  ms: '马来语',
  mt: '马耳他语',
  my: '缅甸语',
  nb: '书面挪威语',
  ndc: '恩道语',
  ne: '尼泊尔语',
  new: '纽瓦尔语',
  nhe: '东瓦斯特卡纳瓦特尔语',
  ni: '纽埃语',
  nl: '荷兰语',
  nn: '新挪威语',
  no: '挪威语',
  nso: '北索托语',
  nus: '努埃尔语',
  ny: '齐切瓦语',
  oc: '奥克语',
  om: '奥罗莫语',
  or: '奥里亚语',
  os: '奥塞提语',
  pa: '旁遮普语',
  pag: '邦阿西楠语',
  pam: '邦板牙语',
  pap: '帕皮阿门托语',
  pl: '波兰语',
  ps: '普什图语',
  pt: '葡萄牙语',
  pt_BR: '巴西葡萄牙语',
  qa: '卡什加语',
  qu: '奇楚瓦语',
  rn: '克伦地语',
  ro: '罗马尼亚语',
  rom: '罗姆语',
  ru: '俄语',
  rw: '卢旺达语',
  sa: '梵语',
  sah: '雅库特语',
  sat: '桑塔利语',
  scn: '西西里语',
  sd: '信德语',
  se: '北萨米语',
  sg: '桑戈语',
  shn: '掸语',
  si: '僧伽罗语',
  sk: '斯洛伐克语',
  sl: '斯洛文尼亚语',
  sm: '萨摩亚语',
  sn: '修纳语',
  so: '索马里语',
  sq: '阿尔巴尼亚语',
  sr: '塞尔维亚语',
  ss: '史瓦帝语',
  st: '塞索托语',
  su: '巽他语',
  sus: '苏苏语',
  sv: '瑞典语',
  sw: '斯瓦希里语',
  szl: '西里西亚语',
  ta: '泰米尔语',
  tcy: '图卢语',
  te: '泰卢固语',
  tet: '德顿语',
  tg: '塔吉克语',
  th: '泰语',
  ti: '提格利尼亚语',
  tiv: '蒂夫语',
  tj: '塔吉克语',
  tk: '土库曼语',
  tl: '他加禄语',
  tm: '塔马舍克语',
  tn: '札那语',
  to: '汤加语',
  tpi: '托克皮辛语',
  tr: '土耳其语',
  trp: '科克伯罗克语',
  ts: '聪加语',
  tt: '鞑靼语',
  tum: '通布卡语',
  tw: '契维语',
  ty: '大溪地语',
  tyv: '图瓦语',
  udm: '乌德穆尔特语',
  ug: '维吾尔语',
  uk: '乌克兰语',
  ur: '乌尔都语',
  uz: '乌兹别克语',
  ve: '文达语',
  vec: '威尼斯语',
  vi: '越南语',
  wa: '瓦隆语',
  war: '瓦瑞语',
  wo: '沃洛夫语',
  xh: '科萨语',
  ye: '耶尼语',
  yi: '意第绪语',
  yo: '约鲁巴语',
  yua: '尤卡坦玛雅语',
  yue: '粤语',
  zap: '萨波特克语',
  zh: '简体中文',
  zh_cn: '简体中文',
  zh_hk: '繁体中文（香港）',
  zh_tw: '繁体中文（台湾）',
  zm: '三宝颜查瓦卡诺语',
  zu: '祖鲁语',
  ae: '阿维斯陀语',
  an: '亚拉冈语',
  bi: '比斯拉马语',
  cu: '教会斯拉夫语',
  ho: '希里木托语',
  hz: '赫雷罗语',
  ia: '因特语',
  ie: '西方国际语',
  ii: '彝语北部方言',
  ik: '依努庇亚克语',
  io: '伊多语',
  ki: '基库尤语',
  kj: '宽亚玛语',
  ks: '克什米尔语',
  lu: '卢巴卡丹加语',
  na: '诺鲁语',
  nd: '北恩德贝莱语',
  ng: '恩敦加语',
  nr: '南恩德贝勒语',
  nv: '纳瓦荷语',
  oj: '欧及布威语',
  pi: '巴利语',
  rm: '罗曼什语',
  sc: '萨丁尼亚语',
  sh: '斯洛文尼亚语',
  vo: '沃拉普克语',
  za: '壮语',
  'zh-tw': '繁体中文',
  unknown: '未区分语种',
};
